<template>
  <div class="page">
    <div class="card_exit" v-if="ShowExit">
      <div class="card_exit_box">
        <p class="card_exit_title">是否确认退出</p>
        <p class="card_exit_describle">
          退出后不会删除任何数据，下次登录依然可用
        </p>
        <div class="card_exit_btn">
          <button class="card_exit_btn_confirm" @click="logout">退出</button>
          <button class="card_exit_btn_fail" @click="exit">取消</button>
        </div>
      </div>
    </div>
     <img
        class="back"
        @click="goHome"
        v-lazy="require('./../../../assets/img/back2.png')"
      />
    <div>
     
      <div class="list" style="height: 91px; line-height: 91px">
        头像<span style="height: 50px"
          ><img
            style="width: 50px; margin-top: 24px"
            v-lazy="user.avatar"
            class="image"
        /></span>
      </div>
      <div class="list">
        昵称<span>{{ user.nick_name }}</span>
      </div>
      <div class="list">
        手机号<span v-if="user.tel">{{
          user.tel.slice(0, 3) + "****" + user.tel.slice(7, 11)
        }}</span
        ><span v-else @click="goLogin" class="more">去绑定 ></span>
      </div>
      <div v-if="isVip" class="list">
        会员有效期<span
          >{{ endTime.split(" ")[0] }}
          <span class="more" @click="goVip">续费 ></span></span
        >
      </div>
      <div @click="showExt" class="loginOut">退出登录</div>
    </div>
    <van-popup
      v-model="showphone"
      @close="close()"
      round
      closeable
      style="background-color: #fff"
    >
      <header class="login">
        <div class="topText">绑定手机号</div>
        <div class="handset ml-20 flex pb-5 number" style="margin-left: 32px">
          <span class="baliu" style="margin-right: 5px">+86 ></span
          ><input
            v-model="phone"
            class="f14"
            type="number"
            placeholder="请输入手机号"
          />
        </div>
        <div class="zhuce"></div>
        <div
          class="handset ml-20 flex jc-sb mt-20 pb-5"
          style="margin-left: 32px; font-size: 15px; margin-right: 30px"
        >
          <input v-model="smsCode" class="f14" placeholder="请输入验证码" />
          <input
            @click="sendCode"
            class="yanzhenma"
            type="button"
            id="getcode"
            value=" 获取验证码"
          />
        </div>
        <button
          @click="login"
          class="butt ml-20 mr-20 fff botton"
          style="background: #42686e; margin-top: 59px; margin-bottom: 16px"
        >
          登录
        </button>
      </header>
    </van-popup>
  </div>
</template>

<script>
import store from "./../../../store/index";
import { mapGetters } from "vuex";
import { smsSend, loginNew1, getMyTest, getUserInfo } from "@/http/api";
export default {
  data() {
    return {
      ShowExit: false,
      showphone: false,
      isVip: false,
      endTime: "",
      phone: "",
      smsCode: "",
      time: 60,
      turn: false,
      t: "",
      // 弹窗
      show: localStorage.vipPopShow != new Date().getDate(),
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    let pro = this.user;
    getUserInfo(pro.user).then((res) => {
      console.log(res);
      const payload = res.data.profile;
      store.commit("updateUser", payload);
      if (payload.is_vip.key == "yes") {
        this.isVip = true;
        this.endTime = payload.valid_date;
      }
    });
  },
  methods: {
    goHome() {
      this.$router.push("/my/center");
    },
    showExt() {
      this.ShowExit = true;
    },
    exit() {
      this.ShowExit = false;
    },
    goLogin() {
      this.showphone = true;
    },
    goVip() {
      if (!localStorage["site_current_token"]) {
        this.$router.push("/login");
      } else {
        this.show = false;
        localStorage.setItem("vipPopShow", new Date().getDate());
        this.$router.push("./vip");
      }
    },
    sendCode() {
      if (this.turn) {
        return;
      }
      if (!/^1[34578]\d{9}$/.test(this.phone)) {
        // alert("手机号码有误，请重填!")
        this.$message({
          message: "手机号码有误，请重填!",
          type: "error",
        });
        return;
      }
      let params = {
        timestamp: new Date().getTime(),
        tel: this.phone,
      };
      let that = this;
      smsSend(params).then((res) => {
        if (res && res.code == "SUCCESS") {
          this.t = setInterval(function () {
            that.countdown();
          }, 1000);
          this.$message({
            message: "获取验证码成功",
            type: "success",
          });
          // alert("获取验证码成功");
          // this.countdown(e)
        } else {
          this.$message({
            message: "res.msg",
            type: "error",
          });
          // alert(res.msg)
        }
      });
    },
    countdown() {
      if (this.time == 0) {
        //这里时设置当时间到0的时候重新设置点击事件，并且默认time修改为60
        this.turn = false;
        document.getElementById("getcode").value = "获取验证码";
        document.getElementById("getcode").style.color = "#7487C3";
        this.time = 60;
        clearInterval(this.t);
      } else {
        //这里是显示时间倒计时的时候点击不生效
        this.turn = true;
        document.getElementById("getcode").value = "重新发送" + this.time;
        document.getElementById("getcode").style.color = "#ccc";
        this.time--;
      }
    },
    login() {
      // 发送请求,用post方式
      // 请求参数
      let params = {
        tel: this.phone,
        timestamp: new Date().getTime(),
        code: this.smsCode,
        // source: 'main_h5'
      };
      clearInterval(this.t);
      loginNew1(params).then((res) => {
        console.log(res);
        if (res.code == "SUCCESS") {
          this.$message({
            message: "手机号绑定成功！",
            type: "success",
          });
          this.showphone = false;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
          // alert(res.data.msg)
        }
      });
    },
    back() {
      history.back();
    },
    logout() {
      // let url = "/logout";
      // let res = await this.$axios.post(url);
      // 修改登陆状态
      const ua = window.navigator.userAgent.toLowerCase();
      let isWechat = ua.match(/MicroMessenger/i) == "micromessenger";
      if (isWechat) {
        this.goLogin();
      }
      store.commit("updateToken", "");
      store.commit("updateUser", "");
      localStorage["token_info_0"] = "";
      localStorage["site_current_token"] = "";

      // this.$store.commit("updateLogin", false);
      // // 把用户名置空
      // this.$store.commit("updateUsername", "");
      // // // 清除token
      // this.$store.commit("updateToken", "");
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="less" scoped>
@import "~Style/index.less";
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 5px;
  top: 5px;
}
/* 本页公共样式 */
.login {
  //height: 100vh;
  background-color: #fff;
}

// 手机号码
header {
  text-align: center;

  img {
    margin: 79px auto;
  }

  // 验证码
  .handset {
    border-bottom: 1px solid #f8f8f8;

    input {
      border: none;
      outline: none;
    }
  }

  // 登录按钮
  .butt {
    margin-top: 20px;
    border-radius: 3px;
    background-color: #ff5f16;
    width: calc((260vw - 5px) / 3);
    height: 40px;
    border: none;
  }
}

.logo {
  font-size: 100px !important;
  margin-bottom: 150px;
}

.topText {
  margin-top: 111px;
  margin-left: 32px;
  margin-bottom: 70px;
  text-align: left;
  font-size: 24px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #4a4a4a;
  line-height: 36px;
}

.botton {
  height: 45px !important;
  background: #42686e !important;
  border-radius: 18px !important;
  font-size: 18px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #ffffff;
  line-height: 27px;
}

.xieyi {
  font-size: 12px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #9b9b9b;
  line-height: 18px;
}

.zhuce {
  margin-bottom: 10px;
  text-align: left;
  margin-left: 32px;
  font-size: 12px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #9b9b9b;
  line-height: 18px;
}

.baliu {
  font-size: 15px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #42686e;
  line-height: 23px;
}

.number {
  font-size: 15px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  line-height: 23px;
}

.yanzhenma {
  background: #fff;

  font-size: 15px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #42686e;
  line-height: 23px;
}

// 上 绑定

.card_exit {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 30;

  .card_exit_box {
    .w(337);
    height: 207px;
    background: #fff;
    border-radius: 32px;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    p {
      text-align: center;
    }

    .card_exit_title {
      font-size: 22px;
      margin-top: 38px;
    }

    .card_exit_describle {
      font-size: 12px;
      color: #9b9b9b;
      line-height: 22px;
    }

    .card_exit_btn {
      .w(302);
      margin: 23px auto 0;
      border-top: 1px solid #eaeaea;
      text-align: center;
      padding-top: 22px;

      button {
        .w(113);
        height: 45px;
        border-radius: 18px;
        font-size: 18px;
        text-align: center;
        line-height: 45px;
        border: none;
      }

      .card_exit_btn_confirm {
        background-color: #eceff5;
        color: #9b9b9b;
        margin-right: 18px;
      }

      .card_exit_btn_fail {
        color: #fff;
        background-color: #42686e;
      }
    }
  }
}

.page {
  background-color: #eaeaea;
  height: 100vh;
}

.list {
  height: 56px;
  border-bottom: 1px solid #eaeaea;
  font-size: 15px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #000000;
  line-height: 56px;
  padding-left: 14px;
  background-color: #fff;

  span {
    float: right;
    font-size: 15px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #9b9b9b;
    margin-right: 18px;
  }

  .more {
    margin-right: 0;
    color: #42686e;
    margin-left: 11px;
  }
}

.loginOut {
  height: 54px;
  font-size: 16px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #000000;
  line-height: 54px;
  text-align: center;
  background-color: #fff;
  margin-top: 7px;
}
</style>
